<template>
    <div style="width: 100%; height: 100%; overflow: auto;background-color: #eef1f4;">
        <el-container style="height:100%">
            <el-header style="padding: 0px">
                <el-row style="height: 60px; line-height: 60px; background-color: #044578;">
                    <el-col :span="1" :offset="2" style="font-size: 30px;color: #ffffff">
                        <div style="width: 100%; height: 100%; cursor: pointer" @click="ret">
                            <i class="el-icon-arrow-left"></i>
                        </div>
                    </el-col>
                    <el-col :span="4"
                    style="text-align: left;
                            font-size: 18px;
                            color: #ffffff;
                            font-weight: bold;">
                        经销商列表
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-row style="font-size: 12px;color: #444444; margin-bottom: 30px; margin-top: 20px">
                    <el-row >
                        <el-col :span="6" :offset="2">
                            用户名 <el-input placeholder="请输入内容" style="margin-left:10px" v-model="where.username" clearable></el-input>
                        </el-col>
                        <el-col :span="6">
                            名称 <el-input placeholder="请输入内容" style="margin-left:10px" v-model="where.name" clearable></el-input>
                        </el-col>
                        <el-col :span="2" :offset="5">
                            <el-button icon="el-icon-search" type="success"  @click="chaxun">查询</el-button>
                        </el-col>
                        <el-col :span="1">
                            <el-button type="success"  icon="el-icon-plus" @click="tianjia"></el-button>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 20px" class="el-button2">
                        
                    </el-row>
                </el-row>
                <el-row style="height:calc(100% - 110px);">
                        <el-col style="height: 100%" :span="20" :offset="2">
                            <el-table
                                :data="tableData"
                                stripe
                                border
                                :header-cell-style="{ 'text-align': 'center', 'background-color': '#f5f7fa' }"
                                :cell-style="{ height: '45px', padding: '0', 'text-align': 'center' }"
                                style="width: 100%;height:calc(100% - 100px)">
                                <el-table-column
                                    type="index"
                                    label="序号"
                                    width="50"
                                    :index="indexMethod">
                                </el-table-column>
                                <el-table-column
                                    prop="username"
                                    label="用户名">
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    label="名称">
                                </el-table-column>
                                <el-table-column
                                    prop="createdtime"
                                    label="创建时间">
                                </el-table-column>
                                <el-table-column
                                    prop="d"
                                    label="更多">
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" content="编辑" placement="bottom-start">
                                            <el-button type="info" size="mini" @click="bianji(scope.row)"><i class="el-icon-edit"></i></el-button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="删除" placement="bottom-start">
                                            <el-button type="info" size="mini" @click="reset(scope.row)"><i class="el-icon-close"></i></el-button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                background
                                :page-sizes="[10, 15, 30, 50, 100]"
                                :current-page="pageset.index"
                                :page-size="pageset.size"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                layout="sizes,prev, pager, next"
                                :total="totalsize"
                                style="float: right; margin-top: 10px"
                                >
                            </el-pagination>
                        </el-col>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import Vue from "vue"
export default {
    name: 'AdminDealer',
    data() {
        return {
            tableData: [],
            pageset: {size:10,index:1,item:1},
            where: {
                username: '',
                name: '',
                mobile: ''
            },
            innerid: '',
            totalsize: 0,
        }
    },
    mounted: function() {
        var self = this;
        self.dealerList()
    },
    methods: {
        // 经销商列表
        dealerList() {
            var self = this
            Vue.axios.post("/aio/dealer/list",{
                where: self.where,
                pageset: self.pageset,
            })
            .then((res) => {
                if(res.data.errcode == 0) {
                    self.tableData = res.data.msgbody
                }
            })
            Vue.axios.post("/aio/dealer/list/count", {
                where: self.where,
                pageset: self.pageset,
            })
            .then((res) => {
                if(res.data.errcode == 0) {
                    self.totalsize = res.data.msgbody
                }
            })
        },
        chaxun(){
            this.dealerList()
        },
        tianjia() {
           this.$router.push({ name: 'DealerAdd' })
        },
        bianji(row) {
            window.localStorage.setItem('edit', JSON.stringify(row))
            this.$router.push({ name: 'DealerEdit' })
        },
        reset(row) {
            var self = this
            self.$confirm('确认要删除此账号？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            })
            .then(() => {
                Vue.axios.post("/aio/dealer/del", {
                    innerid: row.innerid
                })
                .then((row) => {
                    if(row.data.errcode == 0) {
                        self.$message({
                            message: "删除成功",
                            type: "success",
                        });
                        Vue.axios.post("/aio/dealer/list",{
                            where: self.where,
                            page: self.pageset,
                            // order:{column:'createdtime',type:'desc'},
                            // querytype:'main',
                            // 'languageid':'Ch',
                            // 'menuKey':'saasuser'
                        })
                        .then((res) => {
                            if(res.data.errcode == 0) {
                                self.tableData = res.data.msgbody
                            }
                        })
                    }else {
                        self.$message({
                            showClose: true,
                            message: res.data.errmsg || "删除失败",
                            type: "error",
                        });
                    }
                })
            })
            
        },
        indexMethod(index){
            return (this.pageset.index-1)*this.pageset.size+index+1;
        },
        handleSizeChange(val) {
            this.pageset.size = val;
            this.dealerList();
        },
        handleCurrentChange(val) {
            this.pageset.index = val;
            this.dealerList();
        },

        // 返回
        ret() {
            this.$router.push({ name: 'Pandect'})
        }
    }
}
</script>
<style scoped>
.el-input{
    width: 230px;
}
.el-input >>> .el-input__inner {
    width: 230px;
    height: 40px;
}
.el-select >>> .el-input__inner {
    width: 230px;
    height: 40px;
}
.el-select >>> .el-input__suffix {
    top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/AdminDealer.vue